<template>
  <div>
    <div class="form-row mt-3 mr-5" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 1">
          <button
            type="button"
            class="btn btn-sm btn-primary el-button--default"
            v-if="this.active < 3"
            @click="previous"
            style="float: right"
          >
            <span>Previous</span>
          </button>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <job-myjobs @jobId="setId" :active="{ active }"></job-myjobs>
    </el-form>
    <el-form v-if="active === 2">
      <myjob-index :id="job_id" :active="{ active }"></myjob-index>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "DatatableWithFilter",
  data() {
    return {
      active: 1,
      job_id: 0,
    };
  },
  methods: {
    setId(id,value) {
      this.active = value;
      this.job_id = id;
    },
    previous() {
        this.active = 1;
    },
  },
};
</script>
